import { HeaderTestIds } from '@trello/webdriverio-tests';
import { Icon, IconColor, IconName } from 'app/common/components/controls';
import { forNamespace, forTemplate } from 'app/common/lib/util/i18n';
import { clientVersion } from '@trello/config';
import { Button } from '@trello/nachos';
import {
  PopoverMenu,
  PopoverMenuButton,
} from 'app/gamma/src/components/popover/popover-menu';
import React, { useState } from 'react';
import preventDefault from 'app/gamma/src/util/prevent-default';

import styles from './channel-switcher.less';
import { CopyHeadURL } from './CopyHeadURL';
import { getMyChannels, getTests } from 'app/gamma/src/selectors/channels';
import { useSelector, useDispatch } from 'react-redux';
import Cookies from 'js-cookie';
import { selectChannel } from 'app/gamma/src/modules/state/ui/channel-switcher';
import { ChannelList } from './ChannelList';

const format = forTemplate('header_channel_picker');
const viewTitle = forNamespace('view title');

interface ChannelSwitcherProps {
  onSelectHydraChooser: () => void;
  onSelectFeatureFlags: () => void;
  onSelectExperiments: () => void;
  onSelectOneTimeMessagesDismissed: () => void;
}

export const ChannelSwitcher = ({
  onSelectHydraChooser,
  onSelectFeatureFlags,
  onSelectExperiments,
  onSelectOneTimeMessagesDismissed,
}: ChannelSwitcherProps) => {
  const channels = useSelector(getMyChannels);
  const activeChannel = channels.find((channel) => channel.active)?.displayName;
  const tests = useSelector(getTests);

  const [, forceUpdate] = useState({});
  const removeCookie = () => {
    Cookies.set('head', '', { path: '/' });
    forceUpdate({});
  };

  const dispatch = useDispatch();
  const onSelectChannel = (channel: string) => {
    dispatch(selectChannel(channel));
  };
  const cookie = Cookies.get('head');

  return (
    <div className={styles.content}>
      <a
        rel="noopener noreferrer"
        target="_blank"
        href="https://trello.atlassian.net/servicedesk/customer/portal/1/group/1"
      >
        <Icon color={IconColor.Red} name={IconName.Warning} />
        <Icon name={IconName.Microphone} />
        {` ${format('log-an-issue')} `}
        <Icon name={IconName.Microphone} />
        <Icon color={IconColor.Red} name={IconName.Warning} />
      </a>
      <hr />
      {cookie && (
        <div>
          <p>
            {format(
              'you-have-a-version-cookie-set-this-is-a-feature-intended-for-client-developers-and-testers-and-will-prevent-you-from-changing-channels',
            )}
          </p>
          <Button appearance="primary" onClick={preventDefault(removeCookie)}>
            {format('remove-cookie')}
          </Button>
        </div>
      )}

      {!cookie && (
        <ChannelList
          onSelectHydraChooser={onSelectHydraChooser}
          onSelectChannel={onSelectChannel}
        />
      )}

      <hr />
      <pre>{`Client: ${clientVersion} (${activeChannel})`}</pre>
      <hr />
      <CopyHeadURL />
      <hr />
      <PopoverMenu className={styles.popoverMenu}>
        <PopoverMenuButton onClick={onSelectFeatureFlags}>
          {viewTitle('feature flags')}
        </PopoverMenuButton>
        {tests && (
          <PopoverMenuButton
            testId={HeaderTestIds.ChannelPickerExperimentsButton}
            onClick={onSelectExperiments}
          >
            {viewTitle('experiments')}
          </PopoverMenuButton>
        )}
        <PopoverMenuButton onClick={onSelectOneTimeMessagesDismissed}>
          oneTimeMessagesDismissed
        </PopoverMenuButton>
      </PopoverMenu>
    </div>
  );
};
